import { useCallback } from 'react';
import { PartRequestByLineFilters } from '../stock-part-requests/types/stockPartRequestTypes';
import { TableFilterKey } from './utils';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { stockPartRequestBulkSelector } from '../../store/selectors/stockBulkSelector';
import { useBulkFilter } from './useBulkFilter';
import { updateStockBulkSelection } from '../../store/thunks/stock/stock-part-requests/stockBulkOperationsThunks';
import { PartRequestBulkItemDto } from './types';
import { BulkRequestTypeEnum } from './BulkRequestTypeEnum';

export interface BulkTableProps {
  filter: PartRequestByLineFilters;
  onFilter: (key: TableFilterKey, value: string) => void;
  rows: PartRequestBulkItemDto[];
  onSelectionChange: (isSelected: boolean, lineId?: number | null) => void;
  bulkCount: number;
  totalCount: number;
  selectedCount: number;
}

export const useBulkTable = (type: BulkRequestTypeEnum | null): BulkTableProps => {
  const [filter, setFilter] = useBulkFilter();
  const listData = useAppSelector(stockPartRequestBulkSelector);
  const dispatch = useAppDispatch();

  const handleFilter = useCallback((key: TableFilterKey, value: string) => {
    setFilter((current) => ({ ...current, [key]: value }));
  }, [setFilter]);

  const handleSelect = useCallback((isSelected: boolean, lineId?: number | null) => {
    dispatch(updateStockBulkSelection({ isSelected, lineId: lineId ?? null, type }));
  }, [dispatch, type]);

  return {
    filter,
    rows: listData.items,
    onFilter: handleFilter,
    onSelectionChange: handleSelect,
    bulkCount: listData.bulkCount,
    totalCount: listData.totalCount,
    selectedCount: listData.selectedCount,
  };
};
